export const images_status = [
  {
    id: 1,
    name: 'Activa'
  },
  {
    id: 2,
    name: 'Inactiva'
  }
]


// WEBPACK FOOTER //
// ./src/components/gallery_images/mocks.js